export default __webpack_public_path__ + "static/media/nav-close-icon.b309eb6a.svg";